export interface PROPS__crypto {
  salt: string;
  except_fields: string[];
  with_protocol: boolean;
}

// todo:move to constants
export const PROPS__crypto_default: PROPS__crypto = {
  salt: '',
  except_fields: [],
  with_protocol: true,
};
